import { render, staticRenderFns } from "./UploadProdaji.vue?vue&type=template&id=b0daf1a4&scoped=true&"
import script from "./UploadProdaji.vue?vue&type=script&lang=js&"
export * from "./UploadProdaji.vue?vue&type=script&lang=js&"
import style0 from "./UploadProdaji.vue?vue&type=style&index=0&id=b0daf1a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0daf1a4",
  null
  
)

export default component.exports